<template>
  <div class="form-group">
    <label for="price-filter" class="mb-2">
      {{ translate(`${translationsDomain}.FILTERS.PRICE_LABEL`) }}
    </label>

    <div class="input-group" :class="{ 'price-filter-invalid': !isPriceValid }">
      <input
        v-model="modelValue.min"
        class="form-control cirx-filter"
        id="min-value-price"
        type="number"
        :placeholder="translate(`${translationsDomain}.FILTERS.MIN_PLACEHOLDER`)"
        @keydown.enter.prevent="onKeydownEnter"
      />

      <input
        v-model="modelValue.max"
        class="form-control cirx-filter"
        id="max-value-price"
        type="number"
        :placeholder="translate(`${translationsDomain}.FILTERS.MAX_PLACEHOLDER`)"
        @keydown.enter.prevent="onKeydownEnter"
      />
    </div>

    <p v-if="!isPriceValid" class="price-filter-warning">
      {{ translate(`${translationsDomain}.FILTERS.PRICE_INVALID`) }}
    </p>
  </div>
</template>

<script>
import useTranslate from "@/core/composables/translate";

export default {
  name: "PriceFilter",

  props: {
    onKeydownEnter: {
      type: Function,
      default: () => {},
    },

    translationsDomain: {
      type: String,
      required: true,
    },

    modelValue: {
      type: Object,
      required: true,
    },
  },

  setup() {
    const { translate } = useTranslate();
    return {
      translate,
    };
  },

  computed: {
    isPriceValid() {
      return this.modelValue.min && this.modelValue.max
        ? parseFloat(this.modelValue.min) <= parseFloat(this.modelValue.max)
        : true;
    },
  },
};
</script>

<style scoped lang="scss">
.price-filter-warning {
  margin: 0.25rem 0 0.5rem 0;
  color: $cirx-primary-red;
  font-size: 0.9rem;
}

#price-filter.price-filter-invalid input {
  border-color: $cirx-primary-red;
}
</style>
